import React from 'react';

/**
 * WHAT WE'RE MAKING — 14 Oct 2026.
 *
 * The approach, written once at setup and barely touched after. It exists
 * because a project in pre-production had nothing on its page to look at:
 * Marjan's was a tracker and a foot, and a schedule is not a reason to open
 * a link.
 *
 * The first paragraph is set large because it is usually the sentence that
 * was pitched; the rest follows at reading size. Paragraphs are split on
 * blank lines, so a producer writing in a plain box gets a laid-out block
 * without being told about formatting.
 *
 * Nothing is invented here. An empty outline draws nothing at all — the
 * block is not rendered, rather than standing there empty.
 */
export function Outline({
  text
}: {
  text: string;
}) {
  const paragraphs = text.split(/\n{2,}/).map(part => part.trim()).filter(Boolean);
  if (paragraphs.length === 0) return null;
  const [lead, ...rest] = paragraphs;
  return <div data-id="element-124" data-mp="8p5f2dmho2ju">
      <p className="m-0 max-w-[46ch] font-display text-[1.45rem] font-light leading-snug sm:text-[1.7rem]" data-id="element-125" data-mp="8rriq269dxws">
        {lead}
      </p>
      {rest.map((paragraph, index) => <p key={index} className="mt-5 m-0 max-w-[58ch] text-[1.02rem] font-light leading-relaxed text-graphite" data-id="element-126" data-mp="393q5o4ijjmhs" data-mpi={index}>
          {paragraph}
        </p>)}
    </div>;
}